import { Activity } from "lucide-react";

import { Badge } from "src/components/ui/badge";
import { storeIntegrationTypes } from "src/lib/constants";
import { useIntegration } from "src/lib/hooks/useIntegration";

const SyncingIndicator = () => {
  const { selectedIntegration } = useIntegration(
    storeIntegrationTypes.shopify,
    {
      doPolling: false,
      queryOnRender: false,
    }
  );

  const isBackgroundSync =
    selectedIntegration?.syncing &&
    selectedIntegration?.syncVisibility === "BACKGROUND";

  if (!isBackgroundSync) {
    return null;
  }

  const percent =
    typeof selectedIntegration?.syncProgressPercent === "number"
      ? Math.min(100, Math.max(0, selectedIntegration.syncProgressPercent))
      : null;

  return (
    <Badge variant="secondary" className="gap-1.5 px-2 py-1 text-xs">
      <Activity className="size-3 animate-pulse" />
      <span className="whitespace-nowrap hidden sm:inline">Syncing</span>
      {percent !== null && <span className="font-medium">{percent}%</span>}
    </Badge>
  );
};

export default SyncingIndicator;
